export default function DashboardPersonaPicker({ value, onChange }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      className="
        h-9 px-3
        bg-slate-900/70
        border border-slate-700
        rounded-md
        text-xs text-gray-200
        focus:outline-none focus:border-accent-info/60
      "
    >
      <option value="">All Dashboards</option>
      <option value="m_a">M & A (Exec)</option>
      <option value="land_owner">Land Owners</option>
      <option value="land_management">Land Management</option>
      <option value="engineering">Engineering</option>
      <option value="production">Production</option>
      <option value="regulatory">Regulatory</option>
      <option value="agency_regulatory"> Agency Regulatory</option>
    </select>
  );
}